export const INVOICE_VARIANT_KEYS = {
  AGGREGATOR: 'aggregator',
  PAYLATER: 'paylater',
};

export const INVOICE_VARIANTS = {
  [INVOICE_VARIANT_KEYS.AGGREGATOR]: {
    invoiceType: INVOICE_VARIANT_KEYS.AGGREGATOR,
    basePath: '/invoice/aggregator',
    pageHeaderLabel: 'Aggregator Invoices',
    breadcrumbListName: 'Aggregator Invoices',
    detailHeading: 'Aggregator Invoice Detail',
    exportFileSuffix: 'Aggregator',
    isPayLaterInvoice: false,
  },
  [INVOICE_VARIANT_KEYS.PAYLATER]: {
    invoiceType: INVOICE_VARIANT_KEYS.PAYLATER,
    basePath: '/invoice/paylater',
    pageHeaderLabel: 'Paylater Invoices',
    breadcrumbListName: 'Paylater Invoices',
    detailHeading: 'Paylater Invoice Detail',
    exportFileSuffix: 'Paylater',
    isPayLaterInvoice: true,
  },
};

export const getInvoiceVariant = (invoiceType) => {
  return INVOICE_VARIANTS[invoiceType] || INVOICE_VARIANTS[INVOICE_VARIANT_KEYS.AGGREGATOR];
};

export const getInvoiceVariantFromPath = (pathname) => {
  if (pathname?.includes('/invoice/paylater')) {
    return INVOICE_VARIANTS[INVOICE_VARIANT_KEYS.PAYLATER];
  }
  return INVOICE_VARIANTS[INVOICE_VARIANT_KEYS.AGGREGATOR];
};

export const buildMerchantInvoiceDetailSegment = (invoiceId, storeId) => {
  if (!invoiceId || !storeId) return undefined;
  return `${invoiceId}_${storeId}`;
};

export const parseMerchantInvoiceDetailSegment = (combinedId) => {
  if (!combinedId) {
    return { invoiceId: undefined, storeId: undefined };
  }
  const sep = combinedId.indexOf('_');
  if (sep <= 0) {
    return { invoiceId: combinedId, storeId: undefined };
  }
  return {
    invoiceId: combinedId.slice(0, sep),
    storeId: combinedId.slice(sep + 1),
  };
};
